import Breadcrumb from "@/components/Breadcrumb";
import Hero2 from "@/components/Hero2";
import OfficeListing from "@/components/OfficeListing";
import ContactHero from "@/components/ContactHero";
import SeoHead from "@/components/SeoHead";
import classes from "./styles.module.scss";

import { offices_helper } from "@/helpers/offices_helper";
import { Cookies } from "@/components";

export default function ContactUsPage({all_offices}) {

  const image = {
    path: "contact_us.contact_hero.image",
  };

  return (
    <>
      <div style={{marginTop: '120px'}}>
        <SeoHead
            page_name={`Contact Us | Xcede Group`}
            canonical_link={`https://www.xcedegroup.com/contact-us`}
          />
        <div className={classes.cont}>
          <Breadcrumb label="Contact Us" />
          <Hero2 readMore={false} highlight="contact us" body="Have a question or need assistance? We're here to help! Xcede Group is truly global with offices across 4 continents. Select a city below to connect with our team of local experts."></Hero2>
        </div>
        <OfficeListing offices={all_offices} />
         <ContactHero dark={true} image={image} title="work for xcede group" 
          subtitle="We believe that unlocking the potential of our workforce through outstanding training, earning potential and reward structures is key to Xcede Group's success." 
          description="We offer all our employees a world-class recruitment environment to support their career growth from trainee level to management and beyond. Our industry-leading incentives include everything from international travel experiences to exciting relocation opportunities across the globe. Find out more about life at Xcede Group!" 
          buttonLabel="Discover Life at Xcede" buttonLink="/join-us" />
      </div>
      
    </>
  );
}

export async function getStaticProps({}) {
  const all_offices = offices_helper.fetch();

  return {
    props: {
      all_offices
    },
  };
}
